import socialApiClient from "../../helpers/services/social-api-client";
import analyticsApiClient from "../../helpers/services/analytics-api-client";
import { blobFromDataURI } from "../../utils";
import { socialPostVideoDirect } from "../../socialPost/helpers/socialVideoDirectUpload";
import { Mentions } from "../../socialPost/interfaces/Mention";
import { PostVideo } from "../../socialPost/interfaces/postVideo";
import { GetYoutubeBindResponse } from "../interface/api/get-youtube-bind";
import { GetYoutubeLoginResponse } from "../interface/api/get-youtube-login";
import {
  PostYoutubeBindRequest,
  PostYoutubeBindResponse,
} from "../interface/api/post-youtube-bind";
import { PostSocialPostResponse } from "../interface/api/post-youtube-socialPost";
import { YoutubeDirectPostPayload } from "../helpers/publishValidation";
import { YoutubeAnalyticsSnapshot } from "./mockInsights";
import { youtubeSettingMapper } from "./mapper";

function appendYoutubeDirectPost(
  bodyFormData: FormData,
  youtubeDirectPost?: YoutubeDirectPostPayload | null
) {
  if (youtubeDirectPost) {
    bodyFormData.append("youtubeDirectPost", JSON.stringify(youtubeDirectPost));
  }
}

export const youtubeApiService = {
  unbind(companyId: string) {
    return socialApiClient()
      .post(`youtube/unbind`, {}, { params: { companyId } })
      .then(({ data }) => data);
  },
  bind(companyId: string, body: PostYoutubeBindRequest) {
    return socialApiClient()
      .post<PostYoutubeBindResponse>(`youtube/bind`, body, {
        params: { companyId },
      })
      .then(({ data }) =>
        youtubeSettingMapper.mapResponseToYoutubeSetting(data)
      );
  },
  get(companyId: string) {
    return socialApiClient()
      .get<GetYoutubeBindResponse>(`youtube`, {
        params: { companyId },
      })
      .then(({ data }) =>
        youtubeSettingMapper.mapResponseToYoutubeSetting(data)
      );
  },
  login(companyId: string) {
    return socialApiClient()
      .get<GetYoutubeLoginResponse>(`youtube/login`, {
        params: { companyId },
      })
      .then(({ data }) =>
        youtubeSettingMapper.mapResponseToYoutubeLoginUrl(data)
      );
  },
  getInsights(companyId: string, since: string, until: string) {
    return analyticsApiClient()
      .get<{ payload: { snapshot: YoutubeAnalyticsSnapshot } }>(
        `youtube/insights`,
        {
          params: { companyId, since, until },
        }
      )
      .then(({ data }) => data.payload.snapshot);
  },
  socialPostVideo(
    text: string,
    mentions: Mentions[],
    video: PostVideo,
    scheduleDate: string,
    repostId: string,
    companyId: string,
    youtubeDirectPost?: YoutubeDirectPostPayload | null
  ) {
    return socialPostVideoDirect({
      companyId,
      socialProvider: "youtube",
      text,
      mentions,
      video,
      scheduleDate,
      repostId,
      youtubeDirectPostPayload: youtubeDirectPost || undefined,
    });
  },
};
